import React, { useState, useEffect } from 'react';
import useStyles from '../../../styles';
import { dateProtoObjectToString } from '../../../services/ConvertService';

import {
  TextField,
  Card,
  CardContent,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';

export default function ClientSummaryAccountSetupFields({ value }) {
  const classes = useStyles();
  const [accountSetupData, setAccountSetupData] = useState({});
  useEffect(() => {
    setAccountSetupData({ ...value });
  }, [value]);

  return (
    <Card className={classes.root} variant="outlined">
      <CardContent>
        <div>
          <form noValidate autoComplete="off">
            <div className={classes.grdRow}>
              <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                <TextField
                  label="Margin Type"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={accountSetupData.marginType}
                />
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                <TextField
                  label="Large Trader ID"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={accountSetupData.largeTraderId}
                />
              </div>
              <div className={classes.grdCell1}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="dayTrader"
                      checked={Boolean(accountSetupData.dayTrader)}
                    />
                  }
                  label="Day Trader"
                />
              </div>
              <div className={classes.grdCell1}>
                <TextField
                  label="Multiplier"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={accountSetupData.multiplier}
                />
              </div>
            </div>
            <div className={classes.grdRow}>
              <div className={classes.grdCell1} style={{ marginRight: 20 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="allowLiquidInvestment"
                      checked={Boolean(accountSetupData.allowLiquidInvestment)}
                    />
                  }
                  label="Allow Liquidation"
                />
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 20 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="accreditedInvestor"
                      checked={Boolean(accountSetupData.accreditedInvestor)}
                    />
                  }
                  label="Accredited Investor"
                />
              </div>

              <div className={classes.grdCell1} style={{ marginRight: 20 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="marginDisclosure"
                      checked={accountSetupData.marginDisclosure}
                    />
                  }
                  label="Margin Disclosure"
                />
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 20 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="marginAgreement"
                      checked={Boolean(accountSetupData.marginAgreement)}
                    />
                  }
                  label="Margin Agreement"
                />
              </div>
            </div>
            <div className={classes.grdRow}>
              <div className={classes.grdCell1} style={{ marginRight: 20 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="fpslParticipant"
                      checked={Boolean(accountSetupData.fpslParticipant)}
                    />
                  }
                  label="FPSL Participant"
                />
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 20 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="fdidFlag"
                      checked={Boolean(accountSetupData.fdidFlag)}
                    />
                  }
                  label="FDID Flag"
                />
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 20 }}>
                <TextField
                  label="FDID"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={accountSetupData.fdid}
                />
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 20 }}>
                <TextField
                  label="FDID End Reason"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={accountSetupData.fdidEndReason}
                />
              </div>
            </div>
            <div className={classes.grdRow}>
              <div className={classes.grdCell1} style={{ marginRight: 20 }}>
                Trading Priviledge
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 20 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="stocks"
                      checked={Boolean(accountSetupData.stocks)}
                    />
                  }
                  label="Stock"
                />
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 20 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="etf"
                      checked={Boolean(accountSetupData.etf)}
                    />
                  }
                  label="ETF"
                />
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 20 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="option"
                      checked={Boolean(accountSetupData.option)}
                    />
                  }
                  label="Option"
                />
              </div>
            </div>
            <div className={classes.grdRow}>
              <div className={classes.grdCell1} style={{ marginRight: 20 }}>
                <TextField
                  label="Investment Objective Code"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={accountSetupData.investmentObjectiveCode}
                />
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 20 }}>
                <TextField
                  label="Investment Objective Date"
                  fullWidth
                  type="date"
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={dateProtoObjectToString(
                    accountSetupData.investmentObjectiveDate
                  )}
                />
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 20 }}>
                <TextField
                  label="Investment Objectives"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={accountSetupData.annualIncome}
                />
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 20 }}>
                <TextField
                  label="Liquid Net Worth"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={accountSetupData.liquidNetWorth}
                />
              </div>
            </div>
            <div className={classes.grdRow}>
              <div className={classes.grdCell1} style={{ marginRight: 20 }}>
                <TextField
                  label="Source of Funds"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={accountSetupData.sourceOfFunds}
                />
              </div>

              <div className={classes.grdCell1} style={{ marginRight: 20 }}>
                <TextField
                  label="Service Bureau"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{ shrink: true }}
                  value={accountSetupData.serviceBureau}
                />
              </div>

              <div
                className={classes.grdCell1}
                style={{ marginRight: 20 }}
              ></div>
              <div
                className={classes.grdCell1}
                style={{ marginRight: 20 }}
              ></div>
            </div>
          </form>
        </div>
      </CardContent>
    </Card>
  );
}
